import React from "react";
import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import electronicsTradingImage from "../Assets/service2.jpg";
import electronicsTradingImage1 from "../Assets/service2.1.jpg";

const ElectronicsTrading = () => {
  return (
    <div>
    <Fixed />
    <div className="bg-gray-100 text-gray-900 pt-20">
      {/* Hero Section with Background Image */}
      <section
        className="relative w-full h-screen flex items-center justify-center bg-cover bg-center"
        style={{ backgroundImage: `url(${electronicsTradingImage1})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-30"></div>
        <div className="relative z-10 text-center text-white px-6">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-5xl font-extrabold"
          >
            Fast & Secure Electronics Shipping Worldwide
          </motion.h1>
          <p className="mt-4 text-lg max-w-2xl mx-auto">
            Your trusted partner in delivering electronics from one place to another with speed and reliability.
          </p>
        </div>
      </section>

      {/* About Our Services */}
      <section className="container mx-auto px-6 py-16 grid md:grid-cols-2 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="bg-white shadow-lg rounded-lg p-8"
        >
          <h2 className="text-4xl font-bold text-slate-800">Seamless Electronics Shipping</h2>
          <p className="mt-6 text-lg text-gray-700 leading-relaxed">
            We specialize in transporting electronics safely and efficiently. Whether you're a retailer, distributor, or
            individual, we ensure secure packaging, fast delivery, and seamless logistics.
          </p>
        </motion.div>
        <motion.img 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          src={electronicsTradingImage} 
          alt="Electronics Shipping" 
          className="rounded-lg shadow-lg"
        />
      </section>

      {/* Key Services Section */}
      <section className="bg-blue-50 py-12">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-slate-800">Why Choose Us?</h2>
          <div className="flex flex-wrap justify-center gap-6 mt-10">
            {[
              "Secure Packaging & Handling",
              "Fast & Reliable Delivery",
              "Global Shipping Network",
              "Real-time Tracking",
              "Affordable Pricing",
              "24/7 Customer Support"
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                className="bg-white p-6 rounded-lg shadow-md w-full sm:w-1/2 lg:w-1/4 border-b-4 border-blue-500"
              >
                <h3 className="text-2xl font-semibold text-blue-600">{service}</h3>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
<section className="container mx-auto px-6 py-16 text-center">
  <h2 className="text-4xl font-bold text-slate-800">How Our Service Works</h2>
  <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8">
    {[
      { title: "Browse & Order", description: "Explore our wide range of electronics and place your order easily." },
      { title: "Secure Packaging", description: "We ensure safe and secure packaging to protect your items." },
      { title: "Fast Global Shipping", description: "Get your electronics delivered quickly and securely worldwide." }
    ].map((step, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: index * 0.2 }}
        className="bg-white p-6 rounded-lg shadow-md border-t-4 border-blue-500"
      >
        <h3 className="text-2xl font-semibold text-blue-600">{step.title}</h3>
        <p className="mt-2 text-gray-700">{step.description}</p>
      </motion.div>
    ))}
  </div>
</section>


      {/* Contact Section */}
      <section className="py-16 text-center bg-white border-t border-gray-300">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-800">Get Started with Electronics Shipping</h2>
          <p className="mt-4 text-lg text-gray-700">Ship electronics securely and affordably with us today!</p>
        </div>
      </section>
    </div>
    <Footer1 />
  </div>
  );
};

export default ElectronicsTrading;
